import { UUID } from "../generic/uuid";
import {
  createWineTypeDtoFromAnalyticWineTypeModel,
  WineTypeModel,
} from "./wineType";
import { createRegionDtoFromAnalyticRegionModel, RegionModel } from "./region";
import { createWineryDtoFromAnalyticWineryModel, WineryModel } from "./winery";
import { WineDto } from "@vini-wine/core-dtos";

export interface WineModel extends UUID {
  // available includes
  wineType?: WineTypeModel;
  region?: RegionModel;
  winery?: WineryModel;

  // transform
  name: string;
}

export const createWineDtoFromAnalyticWineModel = (
  wine: WineModel,
): WineDto => {
  return {
    uuid: wine.uuid,
    name: wine.name,
    wineType: wine.wineType
      ? createWineTypeDtoFromAnalyticWineTypeModel(wine.wineType)
      : undefined,
    region: wine.region
      ? createRegionDtoFromAnalyticRegionModel(wine.region)
      : undefined,
    winery: wine.winery
      ? createWineryDtoFromAnalyticWineryModel(wine.winery)
      : undefined,
  };
};
